
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { NextPage } from "next/types";
// import { React360Viewer } from 'react-360-product-viewer';
import { LightgalleryItem, LightgalleryProvider } from "react-lightgallery";
import "lightgallery.js/dist/css/lightgallery.css";
import { NextSeo } from "@components/seo";
import useTranslation from "next-translate/useTranslation";
interface IPhoto {
    group: string;
    image: string;
    thumb: string;
    title: string;
}
const PhotoItem = ({ image, thumb, group, title }: IPhoto) => (<div className="image-container relative m-1 max-h-[160px] w-[290px] max-w-[340px] overflow-hidden border">
    <LightgalleryItem group={group} src={image} thumb={thumb}>
      <img alt={title} className="cursor-pointer" height={160} src={thumb} width={290}/>
      <div className="image-title flex h-full items-center justify-center">
        {title}
      </div>
    </LightgalleryItem>
  </div>);
interface GoldGradientTextProps {
    children: string;
}
const GoldGradientText: React.FC<GoldGradientTextProps> = ({ children }) => (<div className="mt-10 flex justify-center">
    <h5 className="bg-gold-gradient px-4 py-2 font-bold text-shadow text-white [text-shadow:_0_1px_0_rgb(0_0_0_/_40%)]">
      {children}
    </h5>
  </div>);
const Gallery: NextPage = () => {
    const { t } = useTranslation("common");
    const IMAGES1 = [
        {
            id: "hala-1",
            title: "Hala produkcyjna",
        },
        {
            id: "hala-2",
            title: "Hala produkcyjna",
        },
        {
            id: "hala-3",
            title: "Hala produkcyjna",
        },
        {
            id: "hala-4",
            title: "Hala produkcyjna",
        },
    ];
    const IMAGES4 = [
        {
            id: "produkcja-ALU-1",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-2",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-3",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-4",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-5",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-6",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-7",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-8",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-9",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-10",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-11",
            title: "Produkcja aluminium",
        },
        {
            id: "produkcja-ALU-12",
            title: "Produkcja aluminium",
        },
    ];
    const IMAGES3 = [
        {
            id: "produkcja-PVC-1",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-2",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-3",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-4",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-5",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-6",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-7",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-8",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-9",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-10",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-11",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-12",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-13",
            title: "Produkcja PVC",
        },
        {
            id: "produkcja-PVC-14",
            title: "Produkcja PVC",
        },
    ];
    const IMAGES5 = [
        {
            id: "KNScargo-1",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-2",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-3",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-4",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-5",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-6",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-7",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-8",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-9",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-10",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-11",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-12",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-13",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-14",
            title: "KNS Transport",
        },
        {
            id: "KNScargo-15",
            title: "KNS Transport",
        },
    ];
    const IMAGES6 = [
        {
            id: "Hotel-Murzasichle-1",
            title: "Stolarka KNS - Realizacje",
        },
        // {
        //   id: 'Hotel-Murzasichle-2',
        //   title: 'Stolarka KNS - Realizacje',
        // },
        {
            id: "Hotel-Murzasichle-3",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Hotel-Murzasichle-4",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Hotel-Murzasichle-5",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Hotel-Murzasichle-6",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Hotel-Murzasichle-7",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Hotel-Murzasichle-8",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Hotel-Murzasichle-9",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Hotel-Murzasichle-10",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Hotel-Murzasichle-11",
            title: "Stolarka KNS - Realizacje",
        },
        {
            id: "Chateau-Bellenau-FR-1",
            title: "Chateau Bellenau FR KNS Windows",
        },
        {
            id: "Chateau-Bellenau-FR-2",
            title: "Chateau Bellenau FR KNS Windows",
        },
        {
            id: "Chateau-Bellenau-FR-3",
            title: "Chateau Bellenau FR KNS Windows",
        },
        {
            id: "Chateau-Bellenau-FR-4",
            title: "Chateau Bellenau FR KNS Windows",
        },
        {
            id: "Chateau-Bellenau-FR-5",
            title: "Chateau Bellenau FR KNS Windows",
        },
        {
            id: "Chateau-Bellenau-FR-6",
            title: "Chateau Bellenau FR KNS Windows",
        },
        {
            id: "Chateau-Bellenau-FR-7",
            title: "Chateau Bellenau FR KNS Windows",
        },
        {
            id: "Chateau-Bellenau-FR-8",
            title: "Chateau Bellenau FR KNS Windows",
        },
    ];
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl/gallery", hrefLang: "x-default" },
            { href: "https://knswindows.com/gallery", hrefLang: "en" },
            { href: "https://knsokna.pl/gallery", hrefLang: "pl" },
            { href: "https://knsfenster.de/gallery", hrefLang: "de" },
            { href: "https://kns-okna.eu/gallery", hrefLang: "cs" },
            { href: "https://knsfinestre.it/gallery", hrefLang: "it" },
            { href: "https://knsfenetres.fr/gallery", hrefLang: "fr" },
            { href: "https://knsokna.eu/gallery", hrefLang: "hu" },
        ]}/>
      <GoldGradientText>{t("gallery.pvc-halls")}</GoldGradientText>
      <div className="mx-auto flex max-w-7xl flex-wrap justify-center px-4 py-2 sm:px-6 lg:px-8">
        <LightgalleryProvider>
          {IMAGES1.map((p) => (<PhotoItem group="group1" image={`/img/gallery/${p.id}.jpg`} key={p.id} thumb={`/img/gallery/${p.id}s.jpg`} title={p.title}/>))}
        </LightgalleryProvider>
      </div>
      {/* <GoldGradientText>HALE PRODUKCYJNE ALUMINIUM</GoldGradientText> */}
      <GoldGradientText>{t("gallery.pvc-production")}</GoldGradientText>
      <div className="mx-auto flex max-w-7xl flex-wrap justify-center px-4 py-2 sm:px-6 lg:px-8">
        <LightgalleryProvider>
          {IMAGES3.map((p) => (<PhotoItem group="group1" image={`/img/gallery/${p.id}.jpg`} key={p.id} thumb={`/img/gallery/${p.id}s.jpg`} title={p.title}/>))}
        </LightgalleryProvider>
      </div>
      <GoldGradientText>{t("gallery.alu-production")}</GoldGradientText>
      <div className="mx-auto flex max-w-7xl flex-wrap justify-center px-4 py-2 sm:px-6 lg:px-8">
        <LightgalleryProvider>
          {IMAGES4.map((p) => (<PhotoItem group="group1" image={`/img/gallery/${p.id}.jpg`} key={p.id} thumb={`/img/gallery/${p.id}s.jpg`} title={p.title}/>))}
        </LightgalleryProvider>
      </div>
      <GoldGradientText>{t("gallery.transport")}</GoldGradientText>
      <div className="mx-auto flex max-w-7xl flex-wrap justify-center px-4 py-2 sm:px-6 lg:px-8">
        <LightgalleryProvider>
          {IMAGES5.map((p) => (<PhotoItem group="group1" image={`/img/gallery/${p.id}.jpg`} key={p.id} thumb={`/img/gallery/${p.id}s.jpg`} title={p.title}/>))}
        </LightgalleryProvider>
      </div>
      <GoldGradientText>{t("gallery.realizations")}</GoldGradientText>
      <div className="mx-auto flex max-w-7xl flex-wrap justify-center px-4 py-2 sm:px-6 lg:px-8">
        <LightgalleryProvider>
          {IMAGES6.map((p) => (<PhotoItem group="group1" image={`/img/gallery/${p.id}.jpg`} key={p.id} thumb={`/img/gallery/${p.id}s.jpg`} title={p.title}/>))}
        </LightgalleryProvider>
      </div>
    </>
    // <div style={{ textAlign: 'center' }}>
    //   <React360Viewer
    //     width={640}
    //     imagesBaseUrl="/img/360/"
    //     imagesCount={37}
    //     imagesFiletype="png"
    //     mouseDragSpeed={20}
    //     imageFilenamePrefix={''}
    //   />
    // </div>
    );
};
export default Gallery;

    async function __Next_Translate__getStaticProps__1a19cd2beb7__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/gallery',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2beb7__ as getStaticProps }
  